const ITEMS = [
  "Jade Residence",
  "Kuta · Lombok · Indonesia",
  "ROI Cash 13,8%",
  "Retorno total 21,0%",
  "Dossier Financiero 2026",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-gold/40 bg-jade py-3.5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-serif text-sm tracking-[0.2em] text-ivory"
              >
                <span className="px-6 uppercase">{t}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
